import { useDispatch, useSelector } from "react-redux"
import { State } from "../reducers"
import { REGEX_EMAIL, REGEX_LETRAS_ESPACIOS, REGEX_NIT, REGEX_NRC } from "../constants/Regex"
import * as http from '../api/http'
import { ENDPOINTS } from "../api/config"
import { KEYS } from "../constants/keysStorage"
import { generalOpenConfirmEdit, generalOpenModalError, generalOpenModalInfo, generalOpenModalMessage, generalOpenToastError, generalOpenToastInfo, generalOpenToastSuccess, generalOpenToastWarning, generalShowLoader, getFechaHora } from "./general.actions"
import { useEffect } from "react"
import FlechaDerechaIcon from '../media/felsv/white_right-arrow_icon.svg'
import EmitirIcon from '../media/felsv/white_check_icon.svg'
import MasOpcionesIcon from '../media/felsv/WhiteOpciones.svg'
import { getEmailNotifyMsg, unirChipsJoin, unirChipsReturnFirst, validarRegexLetras, validarRegexNumericoFloat2Decimales, validaRegexNumericoFloatNDecimales, validarRegexNumericoInt } from "../utils/strings.utils"
import { getMunicipios } from "./catalogos.actions"
import { facturacionGetUUID } from "./facturacion/facturacionEmision.actions"
import { convertDateFormatAnular, getFechaCA, getFechaFormato1 } from "../utils/stringDate"
import { anularFactura, anularFactura_DTE, generateQRImageFromBits, getExcelFactura, getFacturaImage, getFacturaPDF_New, getQR, sendTransactionEmail, descargarJson } from "./operaciones/operaciones.actions"
import { useHistory } from "react-router-dom"
import { OPSendEmail } from "../interfaces/operaciones.interface"
import { ActionNCE, NCEProducto } from "../interfaces/nota-credito-externo.interfaces"
import { NOTA_CREDITO_EXTERNO_TYPES } from "../constants/nota-credito-externo.types"
import { docsAsociadosReset, docsDatosReceptorSiguienteDispatch } from "./documentos/documentos.actions"
import { docsAsociadosItems } from "../pages/EmitirFactura/Components/GeneracionFactura/OtrosDocAsociados"
import { showMessageSucursalVacia } from "./userLogin.actions"
import { handleRestartStateFormaPago } from "./forma-pago.actions"
import { DocFisico } from "../interfaces/general.interface"
import { convertirNumeroConComas } from "../utils/numbers.utils"
import { formatearNum } from "../pages/DetalleFactura/Components/VisualizacionFactura/TotalesDetalle"
import useUtilsDocs, {getDigitosCalculables, isEmpresa3Digitos} from "./utils-documentos.actions"

export default function useNotaCreditoExterno (){
    const dteCode = "05";
    const {formCliente, formProducto, errorsCliente, errorsProducto, productos, view, productoEdit, productoIndex, response_Emitir, clienteEncontrado, retencionRenta: quitarRetencionRenta, documentosFisico, formProductoDescuento, formObservaciones} = useSelector((state: State) => state.notaCreditoExterno)
    const {departamentos, actividadesEconomicas, datosEmisor, unidadesMedida, tipoDocumentosEmision} = useSelector((state: State) => state.catalogos)
    const {pagoCompletado, formFormaPago, pagos} = useSelector((state: State) => state.formaPago)
    const {datosUUID} = useSelector((state: State) => state.facturacion)
    const {datos} = useSelector((state: State) => state.userLogin)
    const {dataDocsAsociados} = useSelector((state: State) => state.documentos.otrosDocumentosAsociados);
    const datosReceptor = useSelector((state: State) => state.documentos.datosReceptor.form);

    const emisorGranContribuyente = datosEmisor?.tipoContribuyente === '1'
    const emisorJuridico = datosEmisor?.tipoEmpresa === '1'
    const dispatch = useDispatch()
    const history = useHistory()

    const {processFormCatalogoProducto, processOtrosImpuestosCalculo, procesOtrosImpuestosResumen} = useUtilsDocs();

    const cargarDatosIniciales = () => {
        let fechaActual = new Date().toISOString().split('T')[0]
        let sucursalConDocumento = formCliente?.datosSucursal?.find((suc: any) => suc.Documento.find((doc: any) => doc.iddocumento === '5'))
        let documentoSucursal = sucursalConDocumento?.Documento.find((doc: any) => doc.iddocumento === '5')

        dispatch(handleSetFormCliente({
            ...formCliente,
            fecha: fechaActual,
            sucursal: sucursalConDocumento?.idsucursal,
            serie: documentoSucursal?.idsucursaldocumento,
            tipoDocumento: "36"
        })) 
    }

    const onChangeFormCliente = (field: string, value: any) => {
        if(!validateChange(field, value) && value.trim() !== '') return
        dispatch(handleSetFormCliente({...formCliente, [field] : value}))
        validateFormCliente(field, value)
    }

    const onChangeFormProducto = (field: string, value: any, extraData = {}) => {
        if(!validateChange(field, value) && value.trim() !== '') return
        dispatch(handleSetFormProducto({...formProducto,  ...extraData, [field] : value}))
        validateFormProducto(field, value)
    }

    const onChangeSelectCatalogoProducto = (codeProduct: string) => {
        const newFormProducto = processFormCatalogoProducto(dteCode, formProducto, codeProduct)
        dispatch(handleSetFormProducto({...formProducto, ...newFormProducto}))
        validateFormProducto('descripcion', codeProduct);
    }

    const validateFormCliente = (field: string, value: string) => {
        let message = ''
        switch (field) {
            case 'nombre':
                if(!value || value.trim() === ''){message = 'Nombre es requerido'; break;}         
                break;
            case 'noDocumento':
                if(!REGEX_NIT.test(value) && value.trim() !== '') {message = 'Formato de NIT incorrecto'; break}
                break;
            case 'departamento':
                if(!value || value.trim() === ''){message = 'Departamento es requerido.'}
                if(value && value !== '' && value !== formCliente.departamento){
                    let nombreDepartamento = departamentos.find(departamento => departamento.codigo === value)?.valor
                    
                    if(nombreDepartamento){
                        dispatch(getMunicipios(parseInt(value), nombreDepartamento, true))
                        dispatch(handleSetFormCliente({...formCliente, departamentoDescripcion: nombreDepartamento, municipio: '', departamento: value}))
                    }
                }
                break;
            case 'municipio':
                if(!value || value.trim() === ''){message = 'Municipio es requerido.'}
                break;
            case 'direccion':
                if(!value || value.trim() === ''){message = 'Dirección es requerida.'}
                break;
            case 'email':
                const chipsEmail = formCliente.chipsEmail?.length || 0;
                if (chipsEmail <= 0 && (!value || value.trim() === '')){message = 'Correo electrónico es requerido.'; break;}
                if (value.trim() !== "" && !REGEX_EMAIL.test(value)) {message = 'Correo electrónico inválido'; break;}
                break;
            case 'telefono':
                if(!value || value.trim() === ''){message = 'Teléfono celular es requerido.'; break;}
                if(value.trim().length < 11){message = 'Teléfono celular inválido.'; break;}
                break;
            case 'actividad':
                if(!value || value.trim() === ''){message = 'Actividad económica es requerida.'; break;}
                break;
            case 'nrc':
                if((!value || value.trim() === '') && formCliente.tipoDocumento === '36'){message = 'NRC es requerido.'; break;}
                if(!REGEX_NRC.test(value) && value.trim() !== ''){message = 'Formato de NRC incorrecto.'}
                break;
            case 'sucursal':
                if(!value || value === ''){message = 'Sucursal es requerida'}
                break;
            case 'serie':
                if(!value || value === ''){message = 'Serie es requerida'}
                break;
        }

        dispatch(handleErrorsFormCliente({
            ...errorsCliente,
            [field] : message
        }))

        return (message)
    }

    const validateFormProducto = (field: string, value: string) => {
        let message = ''
        
        switch(field){
            case 'descripcion':
                if(value.trim() === ''){message = 'Descripción es obligatoria.'; break;}
                break;
            case 'cantidad':
                if(value.trim() === '' || parseFloat(value) === 0){message = 'La cantidad debe ser mayor a 0.'; break;}
                break;
            case 'precio':
                if(value.trim() === '' || parseFloat(value) < 0){message = 'El precio debe ser mayor a 0.'; break;}
                break;
            case 'descuento':
                let suma = parseFloat(formProducto.cantidad) * parseFloat(formProducto.precio)
                if(parseFloat(value) > 100 && formProducto.tipoDescuento === 'Porcentaje') {message = 'El porcentaje de descuento no puede ser mayor al 100%.'; break;}
                if(formProducto.tipoDescuento === 'Monto'){
                    if(parseFloat(value) > suma){message = 'El monto de descuento no puede ser mayor al precio.'; break;}
                }
                break;
        }
        dispatch(handleErrorsFormProducto({
            ...errorsProducto,
            [field] : message
        }))

        return (message)
    }

    const validateFormProductoEdit = (field: string, value: string) => {
        let message = ''
        
        switch(field){
            case 'descripcion':
                if(value.trim() === ''){message = 'Descripción es obligatoria.'; break;}
                break;
            case 'cantidad':
                if(value.trim() === '' || parseFloat(value) === 0){message = 'La cantidad debe ser mayor a 0.'; break;}
                break;
            case 'precio':
                if(value.trim() === '' || parseFloat(value) < 0){message = 'El precio debe ser mayor a 0.'; break;}
                break;
            case 'descuento':
                let suma = parseFloat(productoEdit.cantidad) * parseFloat(productoEdit.precio)
                if(parseFloat(value) > 100 && productoEdit.tipoDescuento === 'Porcentaje') {message = 'El porcentaje de descuento no puede ser mayor al 100%.'; break;}
                if(productoEdit.tipoDescuento === 'Monto'){
                    if(parseFloat(value) > suma){message = 'El monto de descuento no puede ser mayor al precio.'; break;}
                }
                break;
        }
        dispatch(handleErrorsFormProducto({
            ...errorsProducto,
            [field] : message
        }))

        return (message)
    }

    const validateChange = (field: string, value: string) => {
        switch(field){
            case 'nombre':
                return (REGEX_LETRAS_ESPACIOS.test(value))
            case 'descripcion':
                    return validarRegexLetras(value);
            case 'cantidad':
                if(isEmpresa3Digitos(datos?.codigo_empresa))
                    return validaRegexNumericoFloatNDecimales(value);
                return validarRegexNumericoFloat2Decimales(value);
            case 'precio':
                    if(parseFloat(value) > 100000000000) return
                    if(isEmpresa3Digitos(datos?.codigo_empresa))
                        return validaRegexNumericoFloatNDecimales(value);
                    return validarRegexNumericoFloat2Decimales(value);
            case 'descuento':
                    if(parseFloat(value) > 100000000000) return
                    if(isEmpresa3Digitos(datos?.codigo_empresa))
                        return validaRegexNumericoFloatNDecimales(value);
                    return validarRegexNumericoFloat2Decimales(value);
            case 'noDocumento':
                if(value.length > 14) return false
                return(validarRegexNumericoInt(value))            
            case 'nrc':
                return (!(value.length > 7))
            default:
                return true
        }
    }

    const cargarSucursales = async() => {
        const newFormCliente = { ...formCliente, datosSucursal: [], loadedSucursal: true };

        try {
            let message = 'No se logró obtener el catalogo de sucursales'
            const response: any = await api_getSucursales({
                idsucursal: `${datos.sucursal_seleccionada}`,
                tipodocumento: '05'
            })
            
            if (response.body && !response.message) {
                const sucursal = response.body;
                const hayDocs = sucursal[0]?.Documento?.length;
                
                if (hayDocs) {
                    newFormCliente.datosSucursal = sucursal;
                }
                dispatch(handleSetFormCliente(newFormCliente));
            } else {
                dispatch(generalOpenModalError(response.message || message))
            }
        } catch (error: any) {
            if(error?.response?.data?.errorCode === 1) { dispatch(handleSetFormCliente(newFormCliente)); return; }
            dispatch(generalOpenModalError(error?.response?.data?.message ?? 'Error al obtener las sucursales', error?.response?.data?.status))
        }
    }

    const button_onClickAgregarProducto = () => {
        let errors: { [key: string]: string } = {};

        Object.keys(formProducto).forEach((key) => {
            if (validateFormProducto(key, formProducto[key])){
                let propiedad = key
                let value = validateFormProducto(key, formProducto[key])
                errors[propiedad] = value
            }
        })
        dispatch(handleErrorsFormProducto({
            ...errorsProducto,
            ...errors
        }))

        if(Object.values(errors).some((err) => err !== '')){
            dispatch(generalOpenModalInfo('Revisa el formulario de producto'))
            return;
        }

        let tempArray = productos
        tempArray.push(formProducto)
        dispatch(handleAddProducto(tempArray))     
        dispatch(generalOpenModalInfo('Producto agregado correctamente.'))   
        dispatch(handleRestartFormProducto())
    }

    const button_onClickLimpiarFormProducto = () => {
        dispatch(handleRestartFormProducto())
        dispatch(handleErrorsFormProducto({
            ...errorsProducto,
            descripcion: '',
            cantidad: '',
            precio: '',
            descuento: ''
        }))
    }

    const footer_onClickNext = async() => {
        switch (view) {
            case 'Formularios':
                let errors: { [key: string]: string } = {};

                Object.keys(formCliente).forEach((key) => {
                if (validateFormCliente(key, formCliente[key])){
                    let propiedad = key
                    let value = validateFormCliente(key, formCliente[key])
                    errors[propiedad] = value
                }
                })
                dispatch(handleErrorsFormCliente({
                    ...errorsCliente,
                    ...errors
                }))
                
                if(!documentosFisico.tipo) {
                    dispatch(generalOpenModalInfo('Debes ingresar un documento físico.'))
                    return;
                }

                if(Object.values(errors).some((err) => err !== '')){
                    dispatch(generalOpenModalInfo('Revisa los datos del formulario de cliente.'))
                    return;
                }

                if(productos.length === 0){
                    dispatch(generalOpenModalInfo('Debes agregar al menos un producto para continuar.'))
                    return;
                }
                
                const datosReceptor:any = dispatch(docsDatosReceptorSiguienteDispatch())
                if(datosReceptor === true) return;

                if(calculosProductos().total > Number(documentosFisico.monto || "0")){
                    dispatch(generalOpenModalInfo(`El total actual de <b>${formatearNum(calculosProductos().total)}</b> excede el monto permitido de <b>$${convertirNumeroConComas(documentosFisico.monto)}</b> del documento original. Por favor, ajusta el monto para no superarlo.`))
                    return;
                }

                if(calculosProductos().total >= 2147483647){
                    dispatch(generalOpenToastError('Las operaciones que intentas realizar estàn fuera del límite permitido'))
                    return;
                }
                
                try {
                    dispatch(generalShowLoader(true))
                    await Promise.all([dispatch(facturacionGetUUID('05', false))])
                } finally {
                    dispatch(generalShowLoader(false))
                }
                dispatch(handleChangeView('Previsualizacion'))
                break;
            case 'Previsualizacion':
                dispatch(handleActiveModalEmitir(true))
                break;
            case 'Detalle':
                dispatch(handleActiveModalMasOpciones(true))
                break;
        }
    }

    const footer_onClickBack = () => {
        switch (view) {
            case 'Formularios':
                if(productos.length > 0) dispatch(handleActiveModalQuitarTodo(true))
                break;
            case 'Previsualizacion':
                dispatch(handleChangeView('Formularios'))
                break;
            case 'Detalle':
                dispatch(docsAsociadosReset());
                dispatch(handleRestarFlujo())
                dispatch(handleRestartStateFormaPago())
                break;
        }
    }

    const footer_textButtons = () => {
        let textBack = ''
        let textNext = ''
        let iconBack = ''
        let iconNext = ''
        switch(view){
            case 'Formularios':
                textBack = 'Quitar todo'
                textNext = 'Siguiente'
                iconBack = ''
                iconNext = FlechaDerechaIcon
                break;
            case 'Previsualizacion':
                textBack = 'Anterior'
                textNext = 'Emitir'
                iconBack = ''
                iconNext = EmitirIcon
                break;
            case 'Detalle':
                textBack = ''
                textNext = 'Más opciones'
                iconBack = ''
                iconNext = MasOpcionesIcon
                break;
        }

        return {
            next: {
                text: textNext,
                icon: iconNext
            },
            back: {
                text: textBack,
                icon: iconBack
            }
        }
    }

    const button_onClickQuitarTodo = () => {
        dispatch(handleAddProducto([]))
        modal_cerrarQuitarTodo()
        dispatch(generalOpenModalInfo('Se eliminaron todos los productos de la lista'))
    }

    const actionButton_editar = (producto: NCEProducto, index: any) => {
        let tempForm: { [key: string]: any } = {
            ...productoEdit,
            ...producto
        }

        let errors: { [key: string]: string } = {};

        Object.keys(tempForm).forEach((key) => {
            if (validateFormProducto(key, tempForm[key])){
                let propiedad = key
                let value = validateFormProducto(key, tempForm[key])
                errors[propiedad] = value
            }
        })
        dispatch(handleErrorsFormProducto({
            ...errors
        }))

        dispatch(handleSetIndexProductoEdit(index))
        dispatch(handleActiveModalEditar(true))
        dispatch(handleSetProductoEdit(producto))
    }
    
    const modal_cerrarModalEditar = () => {
        button_onClickLimpiarFormProducto()
        dispatch(handleSetIndexProductoEdit(null))
        dispatch(handleActiveModalEditar(false))
        dispatch(handleSetProductoEdit({
            ...productoEdit,
            descripcion: '',
            cantidad: '',
            precio: '',
            descuento: ''
        }))
        
    }

    const actionButton_eliminarProducto = (index: any) => {
        dispatch(handleSetIndexProductoEdit(index))
        dispatch(handleActiveModalEliminar(true))
    }
    
    const modal_button_onConfirmEliminar = () => {
        let tempArray = productos
        tempArray.splice(productoIndex, 1)
        dispatch(handleAddProducto(tempArray))
        dispatch(generalOpenModalInfo('Producto eliminado exitosamente.'))
        modal_cerrarModalEliminar()
    }
    
    const modal_cerrarModalEliminar = () => {
        dispatch(handleSetIndexProductoEdit(null))
        dispatch(handleActiveModalEliminar(false))
    }

    const modal_onChangeFormProductoEdit = (field: string, value: string) => {
        if(!validateChange(field, value) && value.trim() !== '') return

        dispatch(handleSetProductoEdit({
            ...productoEdit,
            [field] : value
        }))

        validateFormProductoEdit(field, value)
    }

    const modal_onChangeSelectCatalogoProductoEdit = (codeProduct: string) => {
        const newFormProductoEdit = processFormCatalogoProducto(dteCode, productoEdit, codeProduct)
        dispatch(handleSetProductoEdit({...productoEdit, ...newFormProductoEdit}))
    }

    const modal_onChangeFormProductoDescuento = (field: string, value: string) => {
        if(!validateChange(field, value) && value.trim() !== '') return
        dispatch(handleSetProductoDescuento({
            ...formProductoDescuento,
            [field] : value
        }))
        validateFormProductoEdit(field, value)
    }

    const modal_button_onConfirmEdit = () => {
        let errors: { [key: string]: string } = {};
        Object.keys(productoEdit).forEach((key) => {
            if (validateFormProducto(key, productoEdit[key])){
                let propiedad = key
                let value = validateFormProductoEdit(key, productoEdit[key])
                errors[propiedad] = value
            }
        })
        dispatch(handleErrorsFormProducto({...errorsProducto, ...errors }))
        if(Object.values(errors).some((err) => err !== '')){
            dispatch(generalOpenModalInfo(`Revisa los datos del ${productoEdit.servicioDescuento ? "descuento" : "producto"}.`))
            return;
        }
        dispatch(generalOpenConfirmEdit(action_onConfirmEdit))
    }

    const modal_button_onConfirmDescuento = () => {
        let errors: { [key: string]: string } = {};

        Object.keys(formProductoDescuento).forEach((key) => {
            if (validateFormProducto(key, formProductoDescuento[key])){
                let propiedad = key
                let value = validateFormProductoEdit(key, formProductoDescuento[key])
                errors[propiedad] = value
            }
        })
        dispatch(handleErrorsFormProducto({
            ...errorsProducto,
            ...errors
        }))

        if(Object.values(errors).some((err) => err !== '')){
            dispatch(generalOpenModalInfo('Revisa los datos del descuento'))
            return;
        }

        let tempArray = productos
        tempArray.push(formProductoDescuento)
        dispatch(handleAddProducto(tempArray))     
        dispatch(generalOpenModalInfo('Descuento agregado correctamente.'))   
        dispatch(handleRestartFormProducto())
        modal_ShowModalDescuento(false)
    }
    

    const action_onConfirmEdit = () => {
        let errors: { [key: string]: string } = {};

        Object.keys(productoEdit).forEach((key) => {
            if (validateFormProducto(key, productoEdit[key])){
                let propiedad = key
                let value = validateFormProductoEdit(key, productoEdit[key])
                errors[propiedad] = value
            }
        })
        dispatch(handleErrorsFormProducto({
            ...errorsProducto,
            ...errors
        }))

        if(Object.values(errors).some((err) => err !== '')){
            dispatch(generalOpenModalInfo(`Revisa los datos del ${productoEdit.servicioDescuento ? "descuento" : "producto"}.`))
            return;
        }

        let tempArray = productos
        tempArray[productoIndex] = productoEdit
        dispatch(handleAddProducto(tempArray))
        modal_cerrarModalEditar()
        dispatch(generalOpenModalInfo(`${productoEdit.servicioDescuento ? "Descuento" : "Producto"} actualizado exitosamente.`))
    }

    const modal_cerrarQuitarTodo = () => {
        dispatch(handleActiveModalQuitarTodo(false))
    }

    const modal_cerrarEmitir = () => {
        dispatch(handleActiveModalEmitir(false))
    }

    const modal_ShowModalDocumento = (open: boolean) => dispatch(handleActiveModalDocFisico(open))
    const guardarDocumentoFisico = (documento: DocFisico) => dispatch(handleSetDocFisico(documento))    
    const modal_ShowModalDescuento = (open: boolean) => dispatch(handleActiveModalDescuento(open))
    
    const modal_button_emitirNuevo = async() => {
        dispatch(handleAddProducto([]))
        dispatch(docsAsociadosReset());
        await dispatch(handleRestartStateFormaPago())
        await dispatch(handleSetFormCliente(
            {
                fecha: '',
                tipoDocumento: '',
                noDocumento: '',
                nombre: '',
                departamento: '',
                municipio: '',
                direccion: '',
                email: '',
                chipsEmail: [],
                telefono: '',
                actividad: '',
                actividadDescripcion: '',
                departamentoDescripcion: '',
                municipioDescripcion: '',
                nrc: '',
                
                datosSucursal: [],
                datosDocumento: [],
        
                sucursal: '',
                serie: '',
                loadedSucursal: false,
            }
        ))
        await dispatch(handleAddProducto([]))
        await dispatch(handleRestarFlujo())
        setTimeout(() => {
            dispatch(handleChangeView('Formularios'))
        }, 2)
        dispatch(handleAddProducto([]))
    }

    const guardarCliente = async() => {
        try {
            let body = {
                opcion: 2,
                tipoDocumento: formCliente.tipoDocumento,
                numDocumento:  formCliente.noDocumento,
                nombre:  formCliente.nombre,
                direccion: formCliente.direccion,
                email: unirChipsJoin(formCliente.chipsEmail, formCliente.email),
                telefono:  formCliente.telefono,
                nrc:  formCliente.nrc,
                codActividad:  formCliente.actividad,
                descActividad:  actividadesEconomicas.find((actividad) => actividad.codigo === formCliente.actividad)?.valor,
                departamento: formCliente.departamento,
                municipio: formCliente.municipio,
              }
            const response: any = await api_buscarCliente(body)
            if (response){
                dispatch(generalOpenToastSuccess(response?.message || "Los datos del cliente han sido guardados satisfactoriamente."))
            }
        } catch (error: any) {
            dispatch(generalOpenToastError(error?.response?.data?.message || 'Se produjo un error al guardar la información del cliente.', "Alerta"))
        }
    }

    const buscarCliente = async() => {
        if(formCliente.noDocumento && (validateFormCliente('noDocumento', formCliente.noDocumento) === '')){
            // dispatch(generalShowLoader(true))
            try {
                let body = {
                    opcion: '1',
                    tipoDocumento: '36',
                    numDocumento: formCliente.noDocumento
                }

                const user: any = await api_buscarCliente(body)

                if(user?.body !== null){
                    if (String(user?.body?.eliminado).toLowerCase() === 'true') { dispatch(generalOpenToastInfo("El cliente es nuevo y será registrado al finalizar la factura, para llenarlo automáticamente en un nuevo documento.", "Aviso")); return; }
                    if (String(user?.body?.activo).toLowerCase() !== 'true') { dispatch(generalOpenToastWarning('Este cliente se encuentra inactivo. Sus datos han sido cargados y puede continuar operando con normalidad.', 'Cliente inactivo')); }
                    if (user?.body?.notificarcorreo?.length > 0) { dispatch(generalOpenModalInfo(getEmailNotifyMsg(user.body.notificarcorreo))); }
                    dispatch(handleSetInfoClienteEncontrado(user.body))
                    dispatch(handleActiveModalClienteEncontrado(true))
                } else {
                    dispatch(generalOpenToastInfo('El cliente es nuevo y será registrado al finalizar la factura, para llenarlo automáticamente en un nuevo documento.', 'Aviso'))
                    dispatch(handleSetInfoClienteEncontrado(null))
                }

            } catch (err: any) {
                dispatch(generalOpenToastError(err?.response?.data?.message || 'Se produjo un error al buscar la información del cliente.', "Alerta"))
            } finally {
                // dispatch(generalShowLoader(false))
            }
        }
    }

    const modal_button_verDetalle = () => {
        dispatch(handleChangeView('Detalle'))
        dispatch(handleActiveModalEmitido(false))
        modal_cerrarEmitir()
    }

    const modal_cerrarMasOpciones = () => {
        dispatch(handleActiveModalMasOpciones(false))
        dispatch(handleActiveModalEmitido(false))
    }

    const modal_button_cerrarModalEmitido = () => {
        dispatch(handleRestarFlujo())
        dispatch(handleRestartStateFormaPago())
        dispatch(docsAsociadosReset());
        dispatch(handleAddProducto([]))
        dispatch(handleActiveModalEmitido(false))
        history.push('/otros-documentos')
    }

    const modal_button_enviarCorreo = () => {
        dispatch(handleActiveModalCorreo(true))
    }

    const modal_button_cerrarEnviarCorreo = () => {
        dispatch(handleActiveModalCorreo(false))
    }

    const modal_button_descargarExcel = async() => {
        try {
            dispatch(generalShowLoader(true))
            await dispatch(getExcelFactura(
                {
                    Documento: response_Emitir.JsonFactura,
                    Sello: response_Emitir.Sello,
                },
                response_Emitir.codigoGeneracion
            ))
        } catch (error) {
            dispatch(generalOpenModalError('Ocurrió un error al descargar el Excel.'))
        } finally {
            dispatch(generalShowLoader(false))
        }
    }

    const modal_button_descargarImagen = async() => {
        try {
            dispatch(generalShowLoader(true))
            await dispatch(getFacturaImage(
                {
                    Documento: response_Emitir.JsonFactura,
                    Sello: response_Emitir.Sello,
                },
                response_Emitir.codigoGeneracion
            ))
        } catch (error) {
            dispatch(generalOpenModalError('Ocurrió un error al descargar la imagen.'))
        } finally {
            dispatch(generalShowLoader(false))
        }
    }

    const modal_button_descargarPDF = async() => {
        try {
            dispatch(generalShowLoader(true))
            await dispatch(getFacturaPDF_New(
                {
                    Documento: response_Emitir.JsonFactura,
                    Sello: response_Emitir.Sello,
                },
                response_Emitir.serie,
                response_Emitir.estadoanulacion
            ))
        } catch (error) {
            dispatch(generalOpenModalError('Ocurrió un error al descargar el PDF.'))
        } finally {
            dispatch(generalShowLoader(false))
        }
    }

    const modal_button_imprimir = () => {
        dispatch(handleActiveModalImprimir(true))
    }

    const modal_cerrarImprimir = () => {
        dispatch(handleActiveModalImprimir(false))
    }

    const modal_button_onClickEnviarCorreo = async(email: string) => {
        try {
            dispatch(generalShowLoader(true))
            const sendEmail: OPSendEmail = {
                Correo: email,
                CorreoCC: formCliente.correocc?.trim() || '',
                Documento: response_Emitir.JsonFactura,
                Sello: response_Emitir.Sello,
                json: response_Emitir?.JsonFacturaFile || "",
                idSucursal: datos?.sucursal_seleccionada,
                idEmpresa: `${datos?.codigo_empresa}`
            }
            const res:any = await dispatch(sendTransactionEmail(sendEmail))
            if(res){
                dispatch(generalOpenModalMessage('Enviar por correo electrónico', 'El correo electrónico fue enviado exitosamente.'))
                return true;
            }
        } catch (error: any) {
            dispatch(generalOpenModalError(error?.response?.data?.message || 'Ocurrió un error al enviar el correo'))
            return false
        } finally {
            dispatch(generalShowLoader(false))
        }
    }

    const modal_button_descargarJson = () => dispatch(descargarJson({idFactura: response_Emitir?.codigoGeneracion, json: response_Emitir?.JsonFacturaFile}))   

    const modal_button_anular = () => dispatch(handleActiveModalAnular(true))
    const modal_cerrarAnular = () => dispatch(handleActiveModalAnular(false))
    const modal_cerrarClienteEncontrado = () => dispatch(handleActiveModalClienteEncontrado(false))
    const productoChangeIva = (flag: boolean) => dispatch(handleSetProductosChangeIva(flag))
    

    const modal_button_aceptarClienteEncontrado = async() => {
        let tempForm: { [key: string]: any } = {
            ...formCliente,
            nombre: clienteEncontrado.nombre,
            tipoDocumento: clienteEncontrado.tipoDocumento,
            noDocumento: clienteEncontrado.numDocumento,
            direccion: clienteEncontrado.direccion,
            email: '',
            chipsEmail: clienteEncontrado.email ? clienteEncontrado.email.split(',').filter((e: string) => e.trim()) : [],
            telefono: clienteEncontrado.telefono,
            nrc: clienteEncontrado.nrc,
            actividad: clienteEncontrado.codActividad,
            departamento: clienteEncontrado.departamento,
            municipio: clienteEncontrado.municipio,
            correocc: clienteEncontrado.correocc ?? ''
        }

        let errors: { [key: string]: string } = {};

        Object.keys(tempForm).forEach((key) => {
            if (validateFormCliente(key, tempForm[key]) && key !== "email"){
                let propiedad = key
                let value = validateFormCliente(key, tempForm[key])
                errors[propiedad] = value
            }
        })
        dispatch(handleErrorsFormCliente({
            ...errors
        }))        

        dispatch(handleSetFormCliente(tempForm))
        modal_cerrarClienteEncontrado()
    }

    const modal_button_onConfirmAnular = async() => {
        dispatch(generalShowLoader(true))

        try {
            //------------------------
            let documento = formCliente?.datosSucursal?.find((sucursal: any) => sucursal?.idsucursal === formCliente?.sucursal)?.Documento?.find((doc: any) => doc?.idsucursaldocumento === formCliente?.serie)
            let serie = `${documento?.serie}-${documento?.numeroactual}`
            let ivaTotal = 0
            productos.forEach((producto) => {
                let precioUnitario = producto.conIva ? parseFloat(producto.precio)/1.13 : parseFloat(producto.precio)
                let ivaProducto = (precioUnitario * 0.13) * parseFloat(producto.cantidad)
                if(!producto.exento){
                    ivaTotal += ivaProducto
                }
            })
            //------------------------

            const anularDoc = {
              documento: response_Emitir.JsonFactura,
              sellorecibido: response_Emitir.Sello,
              DetallesDTE: {
                receptor: {
                  numDocumento: formCliente.noDocumento,
                  tipoDocumento: formCliente.tipoDocumento,
                  nrc: formCliente.nrc,
                  nombre: formCliente.nombre?.trim(),
                  telefono: formCliente.telefono?.trim(),
                  correo: unirChipsReturnFirst(formCliente.chipsEmail, formCliente.email),
                },
                emisor: {
                  nombre: datosEmisor.nombre,
                  nit: datosEmisor.nit,
                  nrc: datosEmisor.nrc,
                  telefono: datosEmisor.telefono,
                  correo: datosEmisor.correo,
                  tipoEstablecimiento: datosEmisor.tipoestablecimiento,
                },
                resumen: {
                  totalIva: isNaN(ivaTotal) ? '0' : `${ivaTotal.toFixed(2)}`,
                },
                identificacion: {
                  tipoDte: '05',
                  codigoGeneracion: response_Emitir.codigoGeneracion,
                  numeroControl: `DTE-05-${serie}`,
                  fecEmi: convertDateFormatAnular(response_Emitir.fhProcesamiento.split(' ')[0]),
                  IDsucursalDoc: documento.idsucursaldocumento
                },
              },
            }
            const response: any = await dispatch(anularFactura_DTE(anularDoc))
            if(response){
                dispatch(generalOpenModalInfo('Documento anulado exitosamente'))
                modal_button_emitirNuevo()
            }
            

        } catch (error: any) {
            dispatch(generalOpenModalError(error?.response?.data?.body?.descripcionMsg || 'Ocurrió un error al anular el documento.'))
        } finally {
            dispatch(generalShowLoader(false))
        }
    }

    const modal_button_emitirDocumento = async() => {
        dispatch(generalShowLoader(true))
        const horasActuales:any = await dispatch(getFechaHora());
        try{
            await guardarCliente()
            //CALCULAR DESCUENTO TOTAL
            let descuentoTotal = 0
            productos.forEach((producto) => {
                let descuento = 
                    producto.tipoDescuento === 'Porcentaje' ? 
                        (parseFloat(producto.descuento || '0')/100 * (producto.conIva ? parseFloat(producto.precio)/1.13 : parseFloat(producto.precio))) * parseFloat(producto.cantidad) :
                        parseFloat(producto.descuento || '0')

                descuentoTotal += descuento
            })

            let documento = formCliente?.datosSucursal?.find((sucursal: any) => sucursal?.idsucursal === formCliente?.sucursal)?.Documento?.find((doc: any) => doc?.idsucursaldocumento === formCliente?.serie)
            let serie = `${documento?.serie}-${documento?.numeroactual}`
            let totalDigitos = getDigitosCalculables(datos?.codigo_empresa)

            let body: any = {
                id_user: localStorage.getItem(KEYS.ID_CLIENT),
                // tipoContribuyente_receptor: formCliente.granContribuyente,
                facturas:
                [{
                    receptorManual: datosReceptor.nombre,
                    docManual: datosReceptor.numId,
                    esReceptorManual : datosReceptor.esReceptorManual,
                    tipoDocManual : datosReceptor.nombreTipoDocumento,
                    idsucursaldocumento: formCliente.serie,
                    receptorEmailsEnvio: unirChipsJoin(formCliente.chipsEmail, formCliente.email),
                    tipoDte:'05',
                    cveDoc: serie,
                    uuid: datosUUID?.CodigoGeneracion,
                    docAnt: documentosFisico.numId,
                    fechaDoc: horasActuales ? (`${horasActuales.FechaDDMM} ${horasActuales.Hora}`) : `${getFechaFormato1()} ${new Date().toLocaleTimeString([], {hour: '2-digit', minute: '2-digit', second: '2-digit'})}`,
                    canTotal: `${calculosProductos().sumaOperaciones.toFixed(totalDigitos)}`,
                    impuTotal: `${calculosProductos().iva.toFixed(2)}`, //Hacienda solo soporta 2 decimales en IVA
                    impuTotal2: `${calculosProductos().ivaRetenido.toFixed(totalDigitos)}`,
                    impuTotal3: `${calculosProductos().ivaPercibido.toFixed(totalDigitos)}`,
                    descuentoTotal: `${descuentoTotal.toFixed(totalDigitos)}`,
                    retencionRenta: `${quitarRetencionRenta ? '0' : calculosProductos().retencionRenta.toFixed(totalDigitos)}`,
                    condicion: "1",
                    receptor: {
                        rfc: formCliente.noDocumento,
                        nit: formCliente.noDocumento,
                        nombre: formCliente.nombre,
                        direccion: formCliente.direccion,
                        email: unirChipsReturnFirst(formCliente.chipsEmail, formCliente.email),
                        telefono: formCliente.telefono,
                        nrc: formCliente.nrc,
                        correocc: formCliente.correocc?.trim() ?? '',
                        codActividad: formCliente.actividad,
                        descAtvividad: actividadesEconomicas.find((actividad) => actividad.codigo === formCliente.actividad)?.valor,
                        departamento: formCliente.departamento,
                        municipio: formCliente.municipio,
                    },
                    docRelacionado: [
                        {
                            tipoDocumento: documentosFisico.tipo,
                            tipoDocRelDesc: tipoDocumentosEmision?.find((tipo) => tipo.codigodocumento === documentosFisico.tipo)?.nombre,
                            numeroDocumento: documentosFisico.numId,
                            DTERelacionado: "--", 
                            fechaEmision: documentosFisico.fecha,
                            fechaDocRel: getFechaCA(documentosFisico.fecha),
                            tipoGeneracion: 1,
                        },
                    ],
                    cuerpoDocumento: productos.map((producto) => {
                        let precioUni = producto.conIva ? parseFloat(producto.precio)/1.13 : parseFloat(producto.precio)
                        let impuestoItem = 0
                        let ivaPercibido = 0
                        let ivaRetenido = 0

                        let descuento = 
                            producto.tipoDescuento === 'Porcentaje' ? 
                                (parseFloat(producto.descuento || '0')/100 * (producto.conIva ? parseFloat(producto.precio)/1.13 : parseFloat(producto.precio))) * parseFloat(producto.cantidad) :
                                parseFloat(producto.descuento || '0') 
            
                        let precio = parseFloat(producto.precio) * parseFloat(producto.cantidad) - descuento
                        if(!producto.exento && emisorJuridico){
                            impuestoItem += precio * 0.13

                            if(emisorGranContribuyente && emisorJuridico && !formCliente.granContribuyente && precio >= 100){
                                ivaPercibido += precio*0.01
                            }

                            if(!emisorGranContribuyente && formCliente.granContribuyente && precio >= 100){
                                ivaRetenido += precio*0.01
                            }
                        }

                        return ({
                            numeroDocumento: documentosFisico.numId,
                            cantidad: `${parseFloat(producto.cantidad).toFixed(totalDigitos)}`,
                            precioUni: `${precioUni.toFixed(totalDigitos)}`,
                            impuesoItem: `${impuestoItem.toFixed(totalDigitos)}`,
                            impuesoItem2: `${ivaRetenido.toFixed(totalDigitos)}`,
                            impuesoItem3: `${ivaPercibido.toFixed(totalDigitos)}`,
                            impuesto: producto.exento ? '0' : "13",
                            impuesto2: producto.exento ? '0' : ivaRetenido > 0 ? '1' : '0',
                            impuesto3: producto.exento ? '0' : ivaPercibido > 0 ? '1' : '0',
                            descripcion: producto.descripcion ,
                            descuento: isNaN(descuento) ? '0' : `${descuento.toFixed(totalDigitos)}`,
                            TipoMonto: producto.exento ? '1' : '0',
                            TipoItem: producto.servicio ? '0' : '1',
                            servicioDescuento: producto.servicioDescuento ? '1' : '0',
                            descUnidad: unidadesMedida.find((unidad) => unidad.codigo === producto.unidadMedida)?.valor,
                            unidad: producto.unidadMedida,
                            tributos: producto.tributos ?? [],
                            codigo: producto.clave ?? '',
                        })
                    }),
                    tributos: calculosProductos().resumenTributos,
                    observaciones: formObservaciones.observaciones,
                    referencia: formObservaciones.referencia,
                    mostrarObservacionesPdf: formObservaciones.mostrarObservacionesPdf,
                    incluirObservacionesCorreo: formObservaciones.incluirObservacionesCorreo,
                }],
                tokenGateway: localStorage.getItem(KEYS.TOKEN) ?? '',
                tokenHacienda: localStorage.getItem(KEYS.HACIENDA) ?? '',
                idSucursal: datos?.sucursal_seleccionada,
                idEmpresa: `${datos?.codigo_empresa}`
            }

                const response: any = await api_RecepcionDTE(body)
                if(response.body.estado === 'PROCESADO'){
                    if(response?.body?.NuevoToken){
                        localStorage.setItem(KEYS.HACIENDA, response?.body?.TokenHacienda)
                      }
                    dispatch(handleSetResponseEmitir(response.body))
                    dispatch(handleActiveModalEmitido(true))
                    dispatch(handleActiveModalEmitir(false))
                    dispatch(handleChangeView('Detalle'))
                  const qrResponse = await getQR(response.body.JsonFactura)
                  if(qrResponse.qr){
                      let qrString = generateQRImageFromBits(qrResponse.qr?.replace("data:image/jpeg;base64,", ""))
                      dispatch(handleSetQRCode(qrString))
                  } else {
                      dispatch(generalOpenModalError(qrResponse.message || 'Ocurrió un error al obtener el código QR'))
                  }
                }

        } catch (err: any) {
            let message = 'Ocurrió un error al emitir el nota de crédito, contacta al administrador.'

            if(err?.response?.data?.message) message = err.response.data.message
            else {
                try{
                    let messageDesc = err?.response?.data?.body?.descripcionMsg?.replace(/\[(\w+)\.(\w+)\]\s(\w+)/, '$2 de $1 : $3').toUpperCase()
                    message = messageDesc || message
                } catch {
                    message = 'Ocurrió un error al emitir el nota de crédito, contacta al administrador.'
                }
            }

            dispatch(generalOpenModalError(message))
        } finally {
            dispatch(generalShowLoader(false))
        }
    }
      

    const calculosProductos = () => {
        let sumaOperaciones = 0
        let iva = 0
        let subtotal = 0
        let ivaPercibido = 0
        let ivaRetenido = 0
        let retencionRenta = 0
        let total = 0
        let otrosImpuestos = 0
        let resumenTributos:Array<any> = [];
        let totalDigitos = getDigitosCalculables(datos?.codigo_empresa)

        productos.forEach((producto) => {
            let descuento = 
            producto.tipoDescuento === 'Porcentaje' ? 
                (parseFloat(producto.descuento || '0')/100 * (producto.conIva ? parseFloat(producto.precio)/1.13 : parseFloat(producto.precio))) * parseFloat(producto.cantidad) :
                parseFloat(producto.descuento || '0') 
            
            let precioConIVA = ((parseFloat(producto.precio)/1.13)) * parseFloat(producto.cantidad) - descuento
            let precioSinIVA = (parseFloat(producto.precio)) * parseFloat(producto.cantidad) - descuento
            let precio = producto.conIva ? precioConIVA : precioSinIVA
            

            if(!producto.exento) iva += (precio * 0.13)

            if(!producto.exento && emisorJuridico){
                if(emisorGranContribuyente && emisorJuridico && !formCliente.granContribuyente){
                    ivaPercibido += parseFloat((precio*0.01).toFixed(2))
                }
            }

            if(!producto.exento){
                if(!emisorGranContribuyente && formCliente.granContribuyente){
                    ivaRetenido += parseFloat((precio*0.01).toFixed(2))
                }
            }

            if(producto.servicio && !emisorGranContribuyente && !emisorJuridico && !quitarRetencionRenta){
                retencionRenta += parseFloat((precio*0.1).toFixed(2))
            }

            sumaOperaciones += precio

            otrosImpuestos += processOtrosImpuestosCalculo(dteCode, producto, precio, false);
            resumenTributos = procesOtrosImpuestosResumen(dteCode, resumenTributos, producto, precio);
        })

        resumenTributos.forEach((resum) => {
            resum.valor = parseFloat(resum.valor.toFixed(totalDigitos));
        });
  
        if(sumaOperaciones < 100 && (ivaPercibido > 0 || ivaRetenido > 0)) {
            ivaRetenido = 0;
            ivaPercibido = 0;
        }
        
        iva = roundTo(iva, 2)
        sumaOperaciones = roundTo(sumaOperaciones, 2)
        subtotal = sumaOperaciones + iva + otrosImpuestos
        total = roundTo(subtotal + ivaPercibido - ivaRetenido - retencionRenta, 2)

    return {
        sumaOperaciones: sumaOperaciones,
        iva: iva,
        subtotal: subtotal,
        ivaPercibido: ivaPercibido,
        ivaRetenido: ivaRetenido,
        retencionRenta: retencionRenta,
        otrosImpuestos: otrosImpuestos,
        resumenTributos: resumenTributos,
        total: total
    }
    }

    const roundTo = (n: number, digits: number) => {
        if (digits === undefined) {
            digits = 0;
        }

        var multiplicator = Math.pow(10, digits);
        n = parseFloat((n * multiplicator).toFixed(11));
        return Math.round(n) / multiplicator;
    }


    const modal_button_anular2 = async () => {
        let documento = formCliente?.datosSucursal?.find((sucursal: any) => sucursal?.idsucursal === formCliente?.sucursal)?.Documento?.find((doc: any) => doc?.idsucursaldocumento === formCliente?.serie)
        let serie = `${documento?.serie}-${documento?.numeroactual}`
        let ivaTotal = 0
        productos.forEach((producto) => {
            let precioUnitario = producto.conIva ? parseFloat(producto.precio)/1.13 : parseFloat(producto.precio)
            let ivaProducto = (precioUnitario * 0.13) * parseFloat(producto.cantidad)
            if(!producto.exento){
                ivaTotal += ivaProducto
            }
        })
        const anularDoc: any = {
          documento: response_Emitir.JsonFactura,
          sellorecibido: response_Emitir.Sello,
          DetallesDTE: {
            receptor: {
                numDocumento: formCliente.noDocumento,
                tipoDocumento: formCliente.tipoDocumento,
                nrc: formCliente.nrc,
                nombre: formCliente.nombre,
                telefono: formCliente.telefono,
                correo: unirChipsReturnFirst(formCliente.chipsEmail, formCliente.email),
              },
            emisor: {
                nombre: datosEmisor.nombre,
                nit: datosEmisor.nit,
                nrc: datosEmisor.nrc,
                telefono: datosEmisor.telefono,
                correo: datosEmisor.correo,
                tipoEstablecimiento: datosEmisor.tipoestablecimiento,
              },
            resumen: {
              totalIva: ivaTotal,
            },
            identificacion: {
              tipoDte: '05',
              codigoGeneracion: response_Emitir.codigoGeneracion,
              numeroControl: `DTE-05-${serie}`,
              fecEmi: convertDateFormatAnular(response_Emitir.fhProcesamiento.split(' ')[0]),
            },
          },
        }
        dispatch(anularFactura([anularDoc]))
      }

    const setTableProductos = (table: any) => {
        dispatch(handleSetTableProductos(table))
    } 

    const handleChangeRetencionRenta = () => {
        dispatch(handleActiveRetencionRenta(!quitarRetencionRenta))
    }

    useEffect(() => {
        let precioUnitario = formProducto.conIva ? parseFloat(formProducto.precio)/1.13 : parseFloat(formProducto.precio)
        let descuento = 0
        if(formProducto.tipoDescuento === 'Porcentaje'){
            descuento = isNaN(parseFloat(formProducto.descuento)) ? 0 : (precioUnitario * parseFloat(formProducto.descuento)/100) * parseFloat(formProducto.cantidad)
        } else {
            descuento = isNaN(parseFloat(formProducto.descuento)) ? 0 : parseFloat(formProducto.descuento)
        }
        let neto = (parseFloat(formProducto.cantidad) * precioUnitario) 
        let subtotal = neto - descuento
        let iva = subtotal * 0.13
        let otrosImpuestos = processOtrosImpuestosCalculo(dteCode, formProducto, subtotal);

        if(formProducto.exento) iva = 0
        let total = subtotal + iva;
        
        dispatch(handleCalculosProducto({
            neto: isNaN(neto) ? '$0.00' : neto.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: getDigitosCalculables(datos?.codigo_empresa), style: 'currency', currency: 'USD'}),
            subtotal: isNaN(subtotal) ? '$0.00' : subtotal.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: getDigitosCalculables(datos?.codigo_empresa), style: 'currency', currency: 'USD'}),
            descuento: isNaN(descuento) ? '$0.00' : descuento.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: getDigitosCalculables(datos?.codigo_empresa), style: 'currency', currency: 'USD'}),
            total: isNaN(total) ? '$0.00' : total.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: getDigitosCalculables(datos?.codigo_empresa), style: 'currency', currency: 'USD'}),
            iva: isNaN(iva) ? '$0.00' : iva.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: getDigitosCalculables(datos?.codigo_empresa), style: 'currency', currency: 'USD'}),
            otrosImpuestos: isNaN(otrosImpuestos) ? '$0.00' : otrosImpuestos.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: getDigitosCalculables(datos?.codigo_empresa), style: 'currency', currency: 'USD'})
        }))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formProducto])

    useEffect(() => {
        if(formProducto.exento) dispatch(handleSetFormProducto({...formProducto, conIva: false,}))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formProducto.exento])

    useEffect(() => {
        if(formProducto.conIva) dispatch(handleSetFormProducto({ ...formProducto, exento: false, }))     
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formProducto.conIva])

    useEffect(() => {
        if(formCliente.tipoDocumento && formCliente.tipoDocumento !== '') validateFormCliente('noDocumento', formCliente.noDocumento) 
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formCliente.tipoDocumento])

    useEffect(() => {
        if(Array.isArray(formCliente.datosSucursal) && formCliente.datosSucursal.length > 0) cargarDatosIniciales()
        else if (formCliente.loadedSucursal) {
            dispatch(showMessageSucursalVacia('Comprobante de nota de crédito'));
            history.push('/home');
            dispatch(handleRestarFlujo());
        } 
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formCliente.datosSucursal, formCliente.loadedSucursal])

    useEffect(() => {
        if(formProducto.descuento) validateFormProducto('descuento', formProducto.descuento) 
        // eslint-disable-next-line react-hooks/exhaustive-deps        
    }, [formProducto])

    useEffect(() => {
        if(productoEdit.descuento) validateFormProductoEdit('descuento', productoEdit.descuento) 
        // eslint-disable-next-line react-hooks/exhaustive-deps        
    }, [productoEdit])

    return {
        cargarSucursales,
        cargarDatosIniciales,
        buscarCliente,

        onChangeFormCliente,
        onChangeFormProducto,
        onChangeSelectCatalogoProducto,

        validateFormCliente,
        validateFormProducto,

        button_onClickAgregarProducto,
        button_onClickLimpiarFormProducto,
        button_onClickQuitarTodo,

        footer_onClickBack,
        footer_onClickNext,
        footer_textButtons,

        actionButton_editar,
        actionButton_eliminarProducto,

        modal_cerrarQuitarTodo,
        modal_cerrarModalEditar,
        modal_cerrarModalEliminar,
        modal_cerrarEmitir,
        modal_cerrarMasOpciones,
        modal_cerrarImprimir,
        modal_cerrarAnular,
        modal_cerrarClienteEncontrado,

        modal_button_onConfirmEdit,
        modal_button_onConfirmEliminar,
        modal_button_emitirDocumento,
        modal_button_emitirNuevo,
        modal_button_verDetalle,
        modal_button_cerrarModalEmitido,    
        modal_button_enviarCorreo,
        modal_button_cerrarEnviarCorreo,
        modal_button_onClickEnviarCorreo,
        modal_button_descargarExcel,
        modal_button_descargarImagen,
        modal_button_descargarPDF,
        modal_button_imprimir,
        modal_button_anular,
        modal_button_onConfirmAnular,
        modal_button_aceptarClienteEncontrado,
        modal_button_anular2,
        modal_button_descargarJson,

        modal_onChangeFormProductoEdit,
        modal_onChangeSelectCatalogoProductoEdit,
        setTableProductos,
        calculosProductos,
        handleChangeRetencionRenta,

        modal_ShowModalDocumento,
        guardarDocumentoFisico,
        modal_ShowModalDescuento,
        modal_onChangeFormProductoDescuento, 
        handleActiveModalDescuento,
        modal_button_onConfirmDescuento,
        productoChangeIva
    }
}

const handleSetFormCliente = (form: any):ActionNCE => ({type: NOTA_CREDITO_EXTERNO_TYPES.NCE_SET_FORM_CLIENTE, payload: form})
const handleSetFormProducto = (form: any):ActionNCE => ({type: NOTA_CREDITO_EXTERNO_TYPES.NCE_SET_FORM_PRODUCTO, payload: form})
const handleErrorsFormCliente = (errors: any):ActionNCE => ({type: NOTA_CREDITO_EXTERNO_TYPES.NCE_HANDLE_ERRORS_CLIENTE, payload:errors})
const handleErrorsFormProducto = (errors: any):ActionNCE => ({type: NOTA_CREDITO_EXTERNO_TYPES.NCE_HANDLE_ERRORS_PRODUCTO, payload:errors})
const handleCalculosProducto = (calculos: any):ActionNCE => ({type: NOTA_CREDITO_EXTERNO_TYPES.NCE_SET_CALCULOS_PRODUCTO, payload: calculos})
const handleAddProducto = (productos: any):ActionNCE => ({type: NOTA_CREDITO_EXTERNO_TYPES.NCE_SET_PRODUCTOS, payload: productos})
const handleRestartFormProducto = ():ActionNCE => ({type: NOTA_CREDITO_EXTERNO_TYPES.NCE_RESTART_FORM_PRODUCTO, payload: null})
const handleChangeView = (view: string):ActionNCE => ({type: NOTA_CREDITO_EXTERNO_TYPES.NCE_SET_VIEW, payload: view})
const handleActiveModalQuitarTodo = (active: boolean):ActionNCE => ({type: NOTA_CREDITO_EXTERNO_TYPES.NCE_ACTIVE_MODAL_QUITAR_TODO, payload: active})
const handleActiveModalEditar = (active: boolean):ActionNCE => ({type: NOTA_CREDITO_EXTERNO_TYPES.NCE_ACTIVE_MODAL_EDITAR_PRODUCTO, payload: active})
const handleActiveModalEliminar = (active: boolean):ActionNCE => ({type: NOTA_CREDITO_EXTERNO_TYPES.NCE_ACTIVE_MODAL_ELIMINAR_PRODUCTO, payload: active})
const handleActiveModalEmitir = (active: boolean):ActionNCE => ({type: NOTA_CREDITO_EXTERNO_TYPES.NCE_ACTIVE_MODAL_EMITIR, payload: active})
const handleActiveModalEmitido = (active: boolean):ActionNCE => ({type: NOTA_CREDITO_EXTERNO_TYPES.NCE_ACTIVE_MODAL_EMITIDO, payload: active})
const handleActiveModalMasOpciones = (active: boolean):ActionNCE => ({type: NOTA_CREDITO_EXTERNO_TYPES.NCE_ACTIVE_MODAL_MAS_OPCIONES, payload: active})
const handleActiveModalCorreo = (active: boolean):ActionNCE => ({type: NOTA_CREDITO_EXTERNO_TYPES.NCE_ACTIVE_MODAL_ENVIAR_CORREO, payload: active})
const handleActiveModalImprimir = (active: boolean):ActionNCE => ({type: NOTA_CREDITO_EXTERNO_TYPES.NCE_ACTIVE_MODAL_IMPRIMIR, payload: active})
const handleActiveModalClienteEncontrado = (active: boolean):ActionNCE => ({type: NOTA_CREDITO_EXTERNO_TYPES.NCE_ACTIVE_MODAL_CLIENTE_ENCONTRADO, payload: active})
const handleActiveModalAnular = (active: boolean):ActionNCE => ({type: NOTA_CREDITO_EXTERNO_TYPES.NCE_ACTIVE_MODAL_ANULAR, payload: active})
const handleSetProductoEdit = (producto: any):ActionNCE => ({type: NOTA_CREDITO_EXTERNO_TYPES.NCE_SET_PRODUCTO_EDIT, payload: producto})
const handleSetIndexProductoEdit = (index: any):ActionNCE => ({type: NOTA_CREDITO_EXTERNO_TYPES.NCE_SET_PRODUCTO_INDEX, payload: index})
const handleSetResponseEmitir = (response: any):ActionNCE => ({type: NOTA_CREDITO_EXTERNO_TYPES.NCE_SET_RESPONSE_EMITIR, payload: response})
const handleSetQRCode = (qr: any):ActionNCE => ({type: NOTA_CREDITO_EXTERNO_TYPES.NCE_SET_QR_CODE, payload: qr})
export const handleRestarFlujo = ():ActionNCE => ({type: NOTA_CREDITO_EXTERNO_TYPES.NCE_RESTART_ALL, payload: true})
const handleSetInfoClienteEncontrado = (info: any):ActionNCE => ({type: NOTA_CREDITO_EXTERNO_TYPES.NCE_SET_CLIENTE_ENCONTRADO, payload: info})
const handleSetTableProductos = (table: any):ActionNCE => ({type: NOTA_CREDITO_EXTERNO_TYPES.NCE_SET_TABLE_PRODUCTOS, payload: table})
const handleActiveRetencionRenta = (active: boolean):ActionNCE => ({type: NOTA_CREDITO_EXTERNO_TYPES.NCE_SET_RETENCION_RENTA, payload: active})
const handleActiveModalDocFisico = (active: boolean):ActionNCE => ({type: NOTA_CREDITO_EXTERNO_TYPES.NCE_ACTIVE_MODAL_DOCUMENTO_FISICO, payload: active})
const handleActiveModalDescuento = (active: boolean):ActionNCE => ({type: NOTA_CREDITO_EXTERNO_TYPES.NCE_ACTIVE_MODAL_DESCUENTO, payload: active})
const handleSetDocFisico = (doc: any):ActionNCE => ({type: NOTA_CREDITO_EXTERNO_TYPES.NCE_SET_DOCUMENTO_FISICO, payload: doc})
const handleSetProductoDescuento = (producto: any):ActionNCE => ({type: NOTA_CREDITO_EXTERNO_TYPES.NCE_SET_PRODUCTO_DESCUENTO, payload: producto})
const handleSetProductosChangeIva= (flag: boolean):ActionNCE => ({type: NOTA_CREDITO_EXTERNO_TYPES.NCE_SET_PRODUCTOS_CHANGE_IVA, payload: flag})
const api_getSucursales = (body: any) => http.post(ENDPOINTS.GESTION_USUARIO_POST_SUCURSALES, body, {}, KEYS.TOKEN)
const api_RecepcionDTE = (body: any) => http.post(ENDPOINTS.FACTURACION_POST_RECEPCION_DTE, body, {}, KEYS.TOKEN)
const api_buscarCliente = (body: any) => http.post(ENDPOINTS.CLIENTE_RECEPTOR_GUARDAR, body,  {}, KEYS.TOKEN)